<template>
  <nav class="navbar">
    <AcountIcon/>
  </nav>
</template>

<script>
import AcountIcon from '@/components/parts/AcountIcon.vue';

export default {
  components: {
    AcountIcon,
  },
};
</script>

<style scoped>
nav.navbar {
  position: fixed;
  z-index: 100;
  top:0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 3rem;
  background-color: #1cc8a0;
}
</style>
